import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-205379be"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "px-2.5 py-1 bg-gray-700 rounded-full" };
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NonFreeLabel',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SvgIcon, {
                    name: "crown",
                    class: "h-4"
                })
            ]));
        };
    }
});
